module.exports = __webpack_public_path__ + "static/media/capri-9.750a503a.jpg";